// extracted by mini-css-extract-plugin
module.exports = {"content":"notify_content__1IwYV","icon":"notify_icon__1nNav","deliveryBackground":"notify_deliveryBackground__3C0zY","deliveryFont":"notify_deliveryFont__1Vddo"};